import { useEffect, useState } from "react";
import type * as L from "leaflet";

import type { Emission } from "src/types";
import { removeAllDrawnLayers } from "src/utils/map.utils";
import { getLeafletMarkerIcon } from "src/utils/marker.utils";

export enum MapMode {
  DRAW = "DRAW",
  OFF = "OFF",
}

export function usePointSourceEmissionDraw(
  map: L.Map,
  emission: Emission,
  callbacks: {
    onDraw: (latlng: L.LatLngLiteral) => void;
  }
) {
  const [mapMode, setMapMode] = useState<MapMode>(MapMode.OFF);

  /**
   * Effects
   */
  useEffect(() => {
    return function cleanup() {
      removeAllDrawnLayers(map);
    };
  }, [map]);

  useEffect(() => {
    if (mapMode === MapMode.DRAW) {
      // @ts-ignore: incomplete type
      map.pm.setGlobalOptions({ hideMiddleMarkers: true });

      // @ts-ignore: incomplete type
      map.on("pm:create", (e: { shape: string; marker: L.Marker }) => {
        if (e.shape === "Marker") {
          map.pm.disableDraw("Marker");
          callbacks.onDraw(e.marker.getLatLng());
          setMapMode(MapMode.OFF);
          map.pm.disableDraw("Marker");
          map.off("pm:create");
        }
      });
      map.pm.enableDraw("Marker", {
        markerStyle: { icon: getLeafletMarkerIcon("new") },
      });

      return function cleanup() {
        map.off("pm:create");
        map.pm.disableDraw("Marker");
      };
    }
    if (mapMode === MapMode.OFF) {
      map.pm.disableDraw("Marker");
      map.off("pm:create");
    }
  }, [mapMode, map, callbacks]);

  /**
   * Functions
   */
  function toggleMapMode() {
    if (mapMode === MapMode.DRAW) setMapMode(MapMode.OFF);
    if (mapMode === MapMode.OFF) setMapMode(MapMode.DRAW);
  }

  return {
    mapMode,
    toggleMapMode,
  };
}
